/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState } from 'react';
import { IPage } from 'src/interfaces';

import {
  Container,
  Breadcrumb,
  PageTitle,
  SectionTitle,
  TableWrapper,
  Table,
  Thead,
  Th,
  Tr,
  Td,
  StatusCell,
  StatusBar,
  LinkText,
  SortIcon,
} from './viewHistorystyles';

import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import InvoiceService from 'src/services/invoice.service';
import { Link, useParams } from 'react-router-dom';
import { InvoiceHistoryModal } from '../personal-info/components/invoice-history-modal';

export const formatInvoiceDate = (isoDate: string): string => {
  const date = new Date(isoDate);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12;

  return `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
};

const InvoiceHistory: React.FC<IPage> = () => {
  const [historyModalIsOpen, setHistoryModalIsOpen] = useState<boolean>(false);
  const [selectedHistory, setSelectedHistory] = useState<any>(null); // store row data here
  const { t } = useTranslation();
  const { invoiceId } = useParams<{ invoiceId: string }>();

  const {
    isFetching: isInvocieFetching,
    data: invoiceData,
    refetch: invoiceRefetch,
  } = useQuery(['invoice-details'], async () => {
    const result = await InvoiceService.getInvoiceDetails({ invoiceId: invoiceId });
    return result.data;
  });

  const { isFetching, data, refetch } = useQuery(['invoice-history'], async () => {
    const result = await InvoiceService.getInvoiceHistory({ invoiceId: invoiceId });
    return result;
  });

  return (
    <Container>
      <InvoiceHistoryModal isOpen={historyModalIsOpen} setIsOpen={setHistoryModalIsOpen} data={selectedHistory} />
      <Breadcrumb>Search Invoices &gt; Invoice Details</Breadcrumb>

      <PageTitle>History</PageTitle>

      {/* Invoice Table */}
      <SectionTitle>Invoice</SectionTitle>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>Worker</Th>
              <Th>Period Ending</Th>
              <Th>Client</Th>
              <Th>Job Title</Th>
              <Th>Hire Type</Th>
              <Th>Total</Th>
              <Th>Status</Th>
              <Th>Version</Th>
            </Tr>
          </Thead>

          <tbody>
            <Tr>
              <Td>{invoiceData?.invoiceShowId}</Td>
              <Td>{invoiceData?.employeeName}</Td>
              <Td>{invoiceData?.periodEnd}</Td>
              <Td>{invoiceData?.clientName}</Td>
              <Td>{invoiceData?.jobTitle}</Td>
              <Td>{invoiceData?.hireType}</Td>
              <Td>{invoiceData?.invoiceAmount}</Td>
              <Td>
                <StatusCell>{invoiceData?.status}</StatusCell>
              </Td>
              <Td>{invoiceData?.version}</Td>
            </Tr>
          </tbody>
        </Table>
      </TableWrapper>

      {/* Change History Table */}
      <SectionTitle>Change History</SectionTitle>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th>Timestamp</Th>
              <Th>User Name</Th>
              <Th>Action Type</Th>
              <Th>Details</Th>
            </Tr>
          </Thead>

          <tbody>
            {data?.map((historyItem: any) => (
              <Tr key={historyItem.timestamp}>
                <Td>{formatInvoiceDate(historyItem.timestamp)}</Td>
                <Td>{historyItem.userName}</Td>
                <Td>{historyItem.actionType}</Td>
                <Td>
                  <LinkText
                    onClick={() => {
                      setSelectedHistory(historyItem); // set clicked row data
                      setHistoryModalIsOpen(true); // open modal
                    }}
                  >
                    View Details
                  </LinkText>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </TableWrapper>
    </Container>
  );
};

export default InvoiceHistory;
